import Home from '../page/home';
import About from '../page/About';
import Portfolio from '../page/Portfolio';
import Contact from '../page/Contact';
import Header from '../layout/Hearder';
function Main() {
    return (
        <>
            <Header />
            <Home />
            <About />
            <Portfolio />
            <Contact />
        </>
    );
}

export default Main;
